<script setup lang="ts">

import { computed } from 'vue';
import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { useForm, Form } from "@library/Components/Forms/Form/v2";
import { LeadOptions, LeadType } from '../../Types/LeadOptions';

import SelectOption from "../../Components/SelectOption.vue";

const lead = useLead();
const form = await useForm( lead );
const presentation = usePresentation();
presentation.backgroundImage = '/images/sample/gkr-watermark.png';

presentation.canProceed = () => lead.interest != null;

const imageSrc = computed( () => {
    if( lead.leadType == LeadType.family ) return 'family'
    if( lead.hasFemale ) return 'girl'
    return 'boy'
})

</script>

<template>

    <Page>
    
        <ImageAndText 
            :src="`/Interest/${imageSrc}.jpg`" 
            floor-shadow 
            border>
            
            <div class="text-xl font-normal tracking-wider">
            
                <h1 v-if="lead.leadType == LeadType.family || lead.hasMaleAndFemale">
                    Karate is a great activity for families and children of all ages.
                </h1>

                <h1 v-else-if="lead.hasFemale">
                    Karate is a fantastic hobby and is very popular with girls these days.
                </h1>

                <h1 v-else="lead.hasMale">
                    Karate is a fantastic hobby and is very popular with boys these days.
                </h1>

            </div>

            <Form 
                :form="form"
                v-slot="{ model, state }"
                class="flex flex-col gap-8">

                <h1 class="mt-6">What interests you in Karate?</h1>

                <SelectOption 
                    v-model="model.interest" 
                    :options="LeadOptions.interest"               
                />

            </Form>

        </ImageAndText>

    </Page>

</template>